/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { useId as h, useUnstyled as z } from "@progress/kendo-react-common";
import { useLocalization as C, useInternationalization as I } from "@progress/kendo-react-intl";
import { useGridState as g } from "./GridState.mjs";
import { cloneReactElement as k } from "./utils/index.mjs";
const H = (t) => {
  const o = h(), n = t.id || o, s = z(), i = C(), c = I(), [, r] = e.useReducer((p) => !p, !0), a = e.useRef(0), l = e.useRef(0), u = e.useRef(0), f = e.useRef(0), d = e.useRef(0), [R, , m] = g();
  return k(t.children, {
    ...R,
    ...m,
    id: n,
    unstyled: s,
    localization: i,
    intl: c,
    scrollLeftRef: a,
    widthRef: l,
    containerHeightRef: u,
    minRowHeightRef: f,
    virtualSkipRef: d,
    forceUpdate: r,
    isClient: !0
  });
};
export {
  H as GridClientContextReader
};
